import { forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/VisibilityOutlined';
import VisibilityOff from '@mui/icons-material/VisibilityOffOutlined';
import { useFormFieldAdornmentStyles } from './use-form-field-adornment-styles';
import * as SDK from '@siloreal:shared:sdk';
import * as UI from '@siloreal:shared:ui';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;

type Props = {
  tid: string;
  name: string;
  required?: boolean;
  validate?: boolean;
  label?: string;
  placeholder?: string;
  size?: 'medium' | 'large';
};

export const password: FR<HTMLInputElement, Props> = forwardRef((props, ref) => {
  const { name = 'password', label = 'Contraseña', placeholder = '', validate = false, ...restProps } = props;

  const [showPassword, setShowPassword] = useState(false);
  const adornmentSx = useFormFieldAdornmentStyles(showPassword);

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <UI.form.field.text
      name={name}
      label={label}
      placeholder={placeholder}
      {...restProps}
      ref={ref}
      type={showPassword ? 'text' : 'password'}
      validator={validate ? SDK.validator.form.password : undefined}
      adornment={
        <InputAdornment position="end" style={{ marginLeft: '1px' }}>
          <IconButton
            aria-label="toggle password visibility"
            onClick={handleTogglePasswordVisibility}
            edge="end"
            sx={adornmentSx}
          >
            {showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </InputAdornment>
      }
      adornmentPosition="end"
    />
  );
});

password.displayName = 'SiloReal-Form-Field-Password';
